import { render, staticRenderFns } from "./FileShow.vue?vue&type=template&id=36f16640&"
import script from "./FileShow.vue?vue&type=script&lang=js&"
export * from "./FileShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports